import { combineReducers } from "redux";
import filterReducer from "./filter/filterReducer";
import postsReducer from "./posts/postsReducer";

const rootReducer = combineReducers({
    post: postsReducer,
    filter: filterReducer,
});

export default rootReducer;